import React from 'react';
import type { StructuredModelContext } from './modelContextTypes';

interface FinalizedContextPanelProps {
    context: StructuredModelContext | null;
    onOpenWorkspace: () => void;
    onChangeNarrative: (narrative: string) => void;
    metadataReady: boolean;
}

const FinalizedContextPanel: React.FC<FinalizedContextPanelProps> = ({
    context,
    onOpenWorkspace,
    onChangeNarrative,
    metadataReady,
}) => {
    const narrative = context?.contextNarrative || context?.analysisSummary || '';
    const hasNarrative = Boolean(narrative.trim());

    return (
        <div className="flex-1 min-h-0 flex flex-col">
            <div className="shrink-0 flex items-center justify-between gap-2 px-3 py-2 border-b border-inherit">
                <p className="dm-context__muted text-[12px]">
                    {metadataReady
                        ? (hasNarrative ? 'Additional context' : 'No additional context yet.')
                        : 'Select metadata first, then attach additional context.'}
                </p>
                <button
                    type="button"
                    onClick={onOpenWorkspace}
                    disabled={!metadataReady}
                    className="dm-source-actions__btn !min-h-0 py-1 px-2 text-[11px] disabled:opacity-40"
                >
                    {hasNarrative ? 'Refine with copilot' : 'Generate with copilot'}
                </button>
            </div>
            <textarea
                className="dm-context-pane__textarea custom-scrollbar"
                value={narrative}
                disabled={!metadataReady}
                placeholder="Type additional context here, or generate it with the copilot."
                onChange={(e) => onChangeNarrative(e.target.value)}
            />
        </div>
    );
};

export default FinalizedContextPanel;
